import React, { FunctionComponent } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import Icon from '../../Icons';

interface ComponentProps {
  color?: string;
  variant?: 'contained' | 'outlined' | 'text';
  size?: string;
  style?: object;
  icon?: string;
  disabled?: boolean;
  clickHandler?: Function;
  hover?: boolean;
}

const useStyles = makeStyles({
  root: {
    background: (props: ComponentProps) => (props.variant === 'contained' ? props.color : 'none'),
    border: (props: ComponentProps) =>
      props.variant === 'outlined' || props.variant === 'contained' ? `1px solid ${props.color || '#e4e4e4'}` : 'none',
    borderRadius: 2,
    color: (props: ComponentProps) => (props.variant === 'contained' ? '#FFFFFF' : props.color || '#4a4a4a'),
    padding: (props: ComponentProps) => (props.size === 'small' ? '5px 12px' : props.icon ? '5px 26px' : '10px 26px'),
    fontSize: '0.875rem',
    lineHeight: 1,
    cursor: 'pointer',
    textTransform: 'none',
    height: (props: ComponentProps) => (props.size === 'small' ? 'auto' : '35px'),
    '&:hover': {
      background: (props: ComponentProps) =>
        props.variant === 'contained' ? '#FFFFFF' : props.variant === 'outlined' && props.hover ? props.color : 'none',
      color: (props: ComponentProps) =>
        props.variant === 'contained' ? props.color : props.variant === 'outlined' && props.hover ? '#FFFFFF' : 'none',
      border: (props: ComponentProps) =>
        props.variant === 'contained' || props.variant === 'outlined' ? `1px solid ${props.color}` : 'none',
    },
    '& img': {
      maxHeight: '20px',
    },
  },
});

const CustomButton: FunctionComponent<ComponentProps> = (props) => {
  const { variant, style, icon, disabled, clickHandler } = props;
  const classes = useStyles(props);
  return (
    <Button
      style={style}
      disableElevation
      onClick={() => {
        if (clickHandler) {
          clickHandler();
        }
      }}
      className={classes.root}
      startIcon={icon ? <Icon name={icon} /> : null}
      variant={variant}
      disabled={disabled}
    >
      {props.children}
    </Button>
  );
};

export default CustomButton;
